import Panel from "../../component/adminPanelList";
import Login from "../../component/loginIn";
import { useAppContext } from "../../route/Context";
import "./css/style.css";
export default function AdminPanel(params) {
    const { isAuthenticated, setIsAuthenticated } =
        useAppContext();
    return (
        <>
            {isAuthenticated ? (
                <Panel />
            ) : (
                <Login
                    key="login"
                    onLogin={() => setIsAuthenticated(true)}
                />
            )}
        </>
    );
}
